module.exports = __webpack_public_path__ + "static/media/percipio-logo-navy.954cd7c8.svg";